import { AfterViewInit, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../base.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ig-powered-by',
  templateUrl: './powered.by.component.html',
  styleUrls: ['./powered.by.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PoweredByComponent extends BaseComponent implements AfterViewInit, OnInit {
  @HostBinding('class') hostClass = '';
  @Input() public style: 'full-vertical' | 'full-horizontal' | 'iti-vertical' | 'iti-horizontal';
  public itiLogoUrl = '';
  public googleLogoUrl = '';
  public hubName = '';

  // these clients want to hide ITI logo
  hideForClients = ['EurekaCA', 'test', 'TalbotCoMD'];

  constructor(public imageService: ImageService, public activatedRoute: ActivatedRoute) {
    super({activatedRoute});
  }

  ngOnInit(): void {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;

    if (this.hideForClients.indexOf(hubName) >= 0) {
      this.hostClass = 'max-w-0';
    }
  }

  public ngAfterViewInit() {
    this.itiLogoUrl = this.imageService.imageSourceUrl(config.serverDomain + '/assets/imgs/iti.png');
    this.googleLogoUrl = this.imageService.imageSourceUrl(config.serverDomain + '/assets/imgs/google-logo.png');
  }

  public gotoITI() {
    window.open('https://iti-digital.com/', '_blank');
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/powered.by/powered.by.component.ts